export default __webpack_public_path__ + "static/media/k8s_gcp.c5724fde.png";